import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { Fragment, useEffect, useState } from 'react';
import { lodash as _ } from '../../../common';
import PositionChip from '../../../components/positions/PositionChip';
import { translate } from '../../../l10n';

const PositionSelector = (props) => {
   const {
      positions,
      onChange,
      selectedPositions,
      variant = 'outlined',
      showLabel = true,
      label = null,
      allowMultiple = false,
      required = false
   } = props;

   let labelCaption = label
      ? label
      : allowMultiple
      ? translate('positions.positionselector.positions.label')
      : translate('positions.positionselector.position.label');
   if (!showLabel) {
      labelCaption = '';
   }

   const [value, setValue] = useState([]);
   const [placeholder, setPlaceholder] = useState(translate('positions.positionselector.placeholder.startTyping'));

   const onClick = (evt) => {
      evt.stopPropagation();
      evt.preventDefault();
   };

   const onLocalChange = (evt, newValue) => {
      let selectedPositions = allowMultiple ? newValue : newValue.length > 0 ? [newValue[newValue.length - 1]] : [];

      setValue(selectedPositions);

      if (!allowMultiple) {
         setPlaceholder('');
      }

      if (onChange) {
         onChange({ positions: selectedPositions });
      }
   };

   useEffect(() => {
      setPlaceholder(value && value.length > 0 ? (allowMultiple ? 'add more...' : '') : 'Start typing...');
   }, [value]);

   useEffect(() => {
      let newValue = _.filter(positions, (l) => {
         return (
            _.findIndex(selectedPositions, (sl) => {
               return sl.no == l.no;
            }) > -1
         );
      });
      newValue = _.sortBy(newValue, (l) => {
         return _.findIndex(selectedPositions, (sl) => {
            return sl.no === l.no;
         });
      });

      setValue(newValue);
   }, [selectedPositions]);

   return (
      <div className={'PositionSelector'} onClick={onClick}>
         <Autocomplete
            multiple
            limitTags={2}
            shrink='true'
            disableClearable={required}
            filterSelectedOptions
            blurOnSelect={false}
            value={value}
            options={positions}
            onChange={onLocalChange}
            disablePortal={true}
            getOptionLabel={(option) => option.name}
            renderOption={(option, { selected }) => (
               <div data-ignore-popper-toggle style={{ width: '100%' }}>
                  {option.name}
               </div>
            )}
            renderInput={(params) => (
               <TextField
                  {...params}
                  InputLabelProps={{
                     shrink: true
                  }}
                  variant={variant}
                  label={labelCaption}
                  placeholder={placeholder}
               />
            )}
            renderTags={(tagValue, getTagProps) => {
               return (
                  <Fragment>
                     {tagValue.map((option, index) => (
                        <PositionChip {...getTagProps({ index })} name={option.name} disableDelete={required} />
                     ))}
                  </Fragment>
               );
            }}
         />
      </div>
   );
};
export default PositionSelector;
